import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getKhsBySemesterAndMhs = createAsyncThunk("khs/getKhsBySemesterAndMhs", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.get(`v1/input/master/khs/mhs/all`);
    const response = await jwtAuthAxios.post(`v1/view/master/khs/mhs/param`,request);
    //const response = await jwtAuthAxios.post(`v1/input/master/khs/mhs/param`,request);
    return response.data;
});

export const getIpsIpk = createAsyncThunk("khs/getIpsIpk", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/by_nim/${request}`);
    return response.data;
});

export const getLastIpsIpk = createAsyncThunk("khs/getLastIpsIpk", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/last/by_nim/${request}`);
    return response.data;
});

// Deret IPS/IPK per periode hasil hitung backend (HitungIpServices) - satu sumber
// angka untuk halaman Indeks Prestasi, Transkrip, dan History Nilai/KHS.
export const getHitungIp = createAsyncThunk("khs/getHitungIp", async(nim) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/hitung/by_nim/${nim}`);
    return response.data;
});

export const getIpsByPeriode = createAsyncThunk("khs/getIpsByPeriode", async({nim, periode}) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/by_nim/${nim}/periode/${periode}`);
    return response.data;
});

export const getAkm = createAsyncThunk("khs/getAkm", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/akm/data`,request);
    return response.data;
});

export const getHistoryNilai = createAsyncThunk("khs/getHistoryNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/history/nilai/by_nim/${request}`);
    return response.data;
});

export const postHistoryNilai = createAsyncThunk("khs/postHistoryNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/history/nilai/by_nim`,request);
    return response.data;
});

// Transkrip halaman /mahasiswa/perkuliahan/history/transkip. Endpoint terpisah dari
// history/nilai karena membaca v_transkip_nilai — satu baris per enrolmen, tanpa
// duplikat feeder vs nilai lokal. `periode` boleh dikosongkan untuk seluruh periode.
export const postTranskipHistory = createAsyncThunk("khs/postTranskipHistory", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/history/transkip/by_nim`,request);
    return response.data;
});

export const getTranskipNilai = createAsyncThunk("khs/getTranskipNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/mahasiswa/transkip/${request}`);
    return response.data;
});

// Alur admin "Tambah ke Transkrip": promosikan satu baris v_transkip_nilai (sudah
// dedup, lihat postTranskipHistory) jadi baris master_transkrip_nilai berstatus
// "validasi", menunggu admin memvalidasi & mengirim ke Neofeeder.
export const insertTranskripNilai = createAsyncThunk("khs/insertTranskripNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/akm/transkrip/insert`,request);
    return response.data;
});

export const getTranskripNilaiByAdmin = createAsyncThunk("khs/getTranskripNilaiByAdmin", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/akm/transkrip/get`,request);
    return response.data;
});

// Mengirim baris master_transkrip_nilai berstatus "validasi" ke Neofeeder
// (InsertTranskripMahasiswa) lalu menandainya "sync_neofeeder".
export const validasiAdminTranskripNilai = createAsyncThunk("khs/validasiAdminTranskripNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/akm/transkrip/validasi`,request);
    return response.data;
});

const initialState = {
    loading: false,
    loadingIpsIpk: false,
    loadingHistoryNilai: false,
    loadingTranskipHistory: false,
    dataKhs : [],
    dataIpsIpk : [],
    dataHistoryNilai : [],
    dataTranskipHistory : [],
    dataLastIpsIpk : {},
    dataIpsByPeriode : {},
    dataHitungIp : [],
    loadingHitungIp: false,
    dataTranskip: [],
    dataAkm : {},
    loadingTranskripAdmin: false,
    responseTranskripList: [],
    responseTranskrip: {}
}

const khsSlice = createSlice({
    name:"khs",
    initialState: initialState,
    reducers: {
        // dataTranskipHistory dipakai bersama oleh beberapa halaman (KHS, Transkrip,
        // History/Transkrip Nilai admin). Halaman yang sengaja tidak auto-load
        // (KHS - harus search periode dulu) perlu memanggil ini di awal supaya
        // tidak menampilkan data basi yang ditinggalkan halaman lain.
        resetTranskipHistory: (state) => {
            state.dataTranskipHistory = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAkm.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAkm.fulfilled, (state, action) => {
                state.dataAkm = action.payload;
                state.loading = false;
            })
            .addCase(getAkm.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getKhsBySemesterAndMhs.pending, (state) => {
                state.loading = true;
            })
            .addCase(getKhsBySemesterAndMhs.fulfilled, (state, action) => {
                state.dataKhs = action.payload;
                state.loading = false;
            })
            .addCase(getKhsBySemesterAndMhs.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(getIpsIpk.pending, (state) => {
                state.loadingIpsIpk = true;
            })
            .addCase(getIpsIpk.fulfilled, (state, action) => {
                state.dataIpsIpk = action.payload;
                state.loadingIpsIpk = false;
            })
            .addCase(getIpsIpk.rejected, (state, action) => {
                state.loadingIpsIpk = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(getHistoryNilai.pending, (state) => {
                state.loadingHistoryNilai = true;
            })
            .addCase(getHistoryNilai.fulfilled, (state, action) => {
                state.dataHistoryNilai = action.payload;
                state.loadingHistoryNilai = false;
            })
            .addCase(getHistoryNilai.rejected, (state, action) => {
                state.loadingHistoryNilai = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(postHistoryNilai.pending, (state) => {
                state.loadingHistoryNilai = true;
            })
            .addCase(postHistoryNilai.fulfilled, (state, action) => {
                state.dataHistoryNilai = action.payload;
                state.loadingHistoryNilai = false;
            })
            .addCase(postHistoryNilai.rejected, (state, action) => {
                state.loadingHistoryNilai = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(postTranskipHistory.pending, (state) => {
                state.loadingTranskipHistory = true;
            })
            .addCase(postTranskipHistory.fulfilled, (state, action) => {
                state.dataTranskipHistory = action.payload;
                state.loadingTranskipHistory = false;
            })
            .addCase(postTranskipHistory.rejected, (state, action) => {
                state.loadingTranskipHistory = false;
                console.error("Error during postTranskipHistory:", action.error);
            })

            .addCase(getLastIpsIpk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getLastIpsIpk.fulfilled, (state, action) => {
                state.dataLastIpsIpk = action.payload;
                state.loading = false;
            })
            .addCase(getLastIpsIpk.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getHitungIp.pending, (state) => {
                state.loadingHitungIp = true;
            })
            .addCase(getHitungIp.fulfilled, (state, action) => {
                state.dataHitungIp = action.payload || [];
                state.loadingHitungIp = false;
            })
            .addCase(getHitungIp.rejected, (state, action) => {
                state.dataHitungIp = [];
                state.loadingHitungIp = false;
                console.error("Error during getHitungIp:", action.error);
            })

            .addCase(getIpsByPeriode.pending, (state) => {
                state.loading = true;
            })
            .addCase(getIpsByPeriode.fulfilled, (state, action) => {
                state.dataIpsByPeriode = action.payload;
                state.loading = false;
            })
            .addCase(getIpsByPeriode.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getIpsByPeriode:", action.error);
            })

            .addCase(getTranskipNilai.pending, (state) => {
                state.loading = true;
            })
            .addCase(getTranskipNilai.fulfilled, (state, action) => {
                state.dataTranskip = action.payload;
                state.loading = false;
            })
            .addCase(getTranskipNilai.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(insertTranskripNilai.pending, (state) => {
                state.loadingTranskripAdmin = true;
            })
            .addCase(insertTranskripNilai.fulfilled, (state, action) => {
                state.responseTranskrip = action.payload;
                state.loadingTranskripAdmin = false;
            })
            .addCase(insertTranskripNilai.rejected, (state, action) => {
                state.loadingTranskripAdmin = false;
            })

            .addCase(getTranskripNilaiByAdmin.pending, (state) => {
                state.loadingTranskripAdmin = true;
            })
            .addCase(getTranskripNilaiByAdmin.fulfilled, (state, action) => {
                state.responseTranskripList = action.payload;
                state.loadingTranskripAdmin = false;
            })
            .addCase(getTranskripNilaiByAdmin.rejected, (state, action) => {
                state.loadingTranskripAdmin = false;
            })

            .addCase(validasiAdminTranskripNilai.pending, (state) => {
                state.loadingTranskripAdmin = true;
            })
            .addCase(validasiAdminTranskripNilai.fulfilled, (state, action) => {
                state.responseTranskrip = action.payload;
                state.loadingTranskripAdmin = false;
            })
            .addCase(validasiAdminTranskripNilai.rejected, (state, action) => {
                state.loadingTranskripAdmin = false;
            })

    }
})

export const { resetTranskipHistory } = khsSlice.actions;
export const khsSelectors = (state) => state.khs;
export default khsSlice.reducer;